module.exports = __webpack_public_path__ + "img/video-16.0e10f918.png";